export default __webpack_public_path__ + "static/media/Logo-Fulll.c01e5a90.png";